// Auto-generated by scripts/generate-registry.mjs from packages/modules/square_storage_box_slip_lid/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const square_storage_box_slip_lid: ModuleSchema = {
  "id": "square_storage_box_slip_lid",
  "uniqueId": "B3D_H3ZAJ",
  "createdAt": "2026-10-28T08:44:01.554Z",
  "updatedAt": "2026-10-28T09:05:59.207Z",
  "label": "Square Storage Box",
  "description": "Square storage box with a 1.5 mm open base and removable slip-on lid.",
  "category": "container",
  "tags": [
    "square-storage-box-slip-lid"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Body Width",
      "min": 80,
      "max": 300,
      "default": 170,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "depth",
      "label": "Body Depth",
      "min": 80,
      "max": 300,
      "default": 170,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Body Height",
      "min": 40,
      "max": 240,
      "default": 130,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "wall",
      "label": "Wall Thickness",
      "min": 1,
      "max": 5,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "lidHeight",
      "label": "Lid Height",
      "min": 8,
      "max": 50,
      "default": 22,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "skirtDepth",
      "label": "Lid Skirt Depth",
      "min": 8,
      "max": 40,
      "default": 18,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "fitClearance",
      "label": "Lid Clearance Per Side",
      "min": 0.15,
      "max": 0.8,
      "default": 0.35,
      "step": 0.05,
      "unit": "mm"
    },
    {
      "key": "retentionPadProtrusion",
      "label": "Snap Hook Grip",
      "min": 0.2,
      "max": 1.2,
      "default": 0.45,
      "step": 0.05,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Box Base (inside)",
      "default": "#64748b",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "lid",
      "label": "Lid (outside slip-on)",
      "default": "#cbd5e1",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "storage_box",
      "label": "Square Storage Box",
      "name": "Square Storage Box",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "base",
          "label": "Box Base (inside)",
          "name": "Box Base (inside)",
          "groupId": 0,
          "colorKey": "base",
          "defaultColor": "#64748b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "lid",
          "label": "Lid (outside slip-on)",
          "name": "Lid (outside slip-on)",
          "groupId": 1,
          "colorKey": "lid",
          "defaultColor": "#cbd5e1",
          "assembled_z_offset": 0,
          "exploded_z_offset": 28,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Box and Lid"
    },
    {
      "id": "base",
      "label": "Download STL - Base",
      "groupId": 0
    },
    {
      "id": "lid",
      "label": "Download STL - Lid",
      "groupId": 1
    }
  ]
};
